// @flow

// Actions
export type ABTestAction = {
  +type: string;
};

export type ABTestState = {
  // key is the experimentId and the value it's the index of the variant
  +chosenVariants?: { [key: string]: number };
};

export type Experiment = {
  experimentId: string;
  experimentLabel: string;
  variants: Variant[];
};

export type Variant = {
  index: number;
  testLabel: string;
  component: any;
};

export const initialState: ABTestState = {};

// Reducer
export default function reducer(state: ABTestState = initialState,
                                action: ABTestAction): ABTestState {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/ab-test/duck.js